var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 444,
    viewBox: "0 0 444 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M418.935 0H25.0645C11.2074 0 0 11.2074 0 25.0645V418.935C0 432.793 11.2074 444 25.0645 444H418.935C432.793 444 444 432.793 444 418.935V25.0645C444 11.2074 432.793 0 418.935 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M326.573 279.778V47.9318C326.573 37.2871 317.924 28.6453 307.228 28.6453H241.345C230.649 28.6453 222 37.2685 222 47.9318V278.09C222 288.735 230.649 297.377 241.345 297.377H285.112C300.179 297.377 312.232 308.948 312.232 323.376V403.23C312.232 413.874 320.881 422.516 331.577 422.516H374.526C385.203 422.516 393.871 413.893 393.871 403.23V320.038C393.871 309.394 385.221 300.752 374.526 300.752H347.629C336.004 300.752 326.592 291.368 326.592 279.778H326.573Z",
    fill: "url(#paint0_linear_11487_25396)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11487_25396",
    x1: 112.118,
    y1: -412.12,
    x2: 531.984,
    y2: -336.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocker);
export default __webpack_public_path__ + "static/media/locker.a9b1fc6360864a65999e938439f37832.svg";
export { ForwardRef as ReactComponent };